module.exports = "<div class=more-options-title><label style=visibility:hidden;height:0><l10n>Travellers</l10n></label><div style=position:relative dropdown-kt details=adults disabled=::disabled styling=small options=::options.adults model=params.Travelers.Adult></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ukrail/directives/templates/travellers.tmpl.html
// module id = 3702
// module chunks = 0